import './style.css';
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BASE_ROUTE, DEFAULT_ROWS, SESSION_EXPIRED_CODE } from "../../../../config";
import { createTimeString, getOrderStatus, numberWithComma } from "../../../../libs/lib";
import { http_request } from "../../../../libs/connection";
import { Button, Collapse, Toast, ToastContainer } from "react-bootstrap";
import Filter from "../../../../components/filter";
import { BsChevronCompactUp, BsChevronCompactDown } from "react-icons/bs";
import { uniq } from 'lodash';
import Decimal from 'decimal.js';

const INIT = 0;
const SEARCH = 1;
const MANUALLY = 2;
var param_status;
var page = 1;

function PurchaseShipList(){
    const [search_params, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [start_date, setStartDate] = useState((function(){ let d = new Date(); d.setMonth(d.getMonth() - 2); return d; })());
    const [end_date, setEndDate] = useState(new Date());
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [el_search, setElSearch] = useState('');
    const [company_fd_search, setCompanyFDSearch] = useState('');
    const [is_loading, setLoadingStatus] = useState(false);
    const [list, setList] = useState([]);
    const [orders, setOrders] = useState([]);
    const [filter_show, showFilter] = useState(false);
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [success_message, setSuccessMessage] = useState('');
    const [error_message, setErrorMessage] = useState('');

    useEffect(()=>{
      param_status = [...(search_params.values())].length ? SEARCH : INIT;
      if(param_status === INIT){
        resetParams();
      }
      page = 1;
      loadData();
    }, [pathname]);
    
    
    useEffect(()=>{
      if(location.search === ''){
        param_status = INIT;
        resetParams();
        loadData();
      }
    }, [location.search]);
    
    useEffect(()=>{
      if(list.length) loadOrders();
    }, [list]);
    
    function resetParams(){
        resetDate();
        resetSearch();
        page = 1;
    }
    function resetDate(){
        setStartDate((function(){ let d = new Date(); d.setMonth(d.getMonth() - 2); return d; })());
        setEndDate(new Date());
    }
    function resetSearch(){
        setSearch('');
        setElSearch('');
    }
    function loadData(){
        if(is_loading) return;
        /*
        查询之前检查状态并决定赋什麽值

        状态分三种：初始(预设参数)、网址设置参数、手动设置参数

        参数优先级分别为：手动参数 > 网址参数 > 预设参数

        页面开始执行时(监听 pathname)，变更状态
        每次手动调整参数后，变更状态

        每次查询后，变更网址参数
        */
        let start_date_value, end_date_value, search_value, el_search_value, company_fd_search_value;
        switch(param_status){
        case INIT:
            start_date_value = createTimeString('y-m-d h:i:s', start_date);
            end_date_value = createTimeString('y-m-d h:i:s', end_date);
        break;
        case SEARCH:
            start_date_value = search_params.get('start_date');
            end_date_value = search_params.get('end_date');
            search_value = search_params.get('search');
            el_search_value = search_params.get('el_search');
            company_fd_search_value = search_params.get('company_fd_search');
            setStartDate(new Date(start_date_value));
            setEndDate(new Date(end_date_value));
            setSearch(search_value);
            setElSearch(el_search_value);
            setCompanyFDSearch(company_fd_search_value);
        break;
        case MANUALLY:
            start_date_value = createTimeString('y-m-d h:i:s', start_date);
            end_date_value = createTimeString('y-m-d h:i:s', end_date);
            search_value = search;
            el_search_value = el_search;
            company_fd_search_value = company_fd_search;
        break;
        }
        
        let params = {
            start: createTimeString('y-m-d ', start_date_value),
            end: createTimeString('y-m-d ', end_date_value),
            page,
            rows: DEFAULT_ROWS
        };
        if(search_value) params.ch_no = search_value;
        if(el_search_value) params.el_no = el_search_value;
        if(company_fd_search_value) params.company_fd_no = company_fd_search_value;

        setLoadingStatus(true);
        http_request('/purchaseShipOrder/list', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let data = res.data.purchase_ship_orders || [];
                if(page === 1){
                  setList(data);
                }else{
                  setList([...list, ...data]);
                }
                setTotal(res.data.total);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        });
    }
    function query(){
        param_status = MANUALLY;
        page = 1;
        setSearchParams({
            start_date: createTimeString('y/m/d', start_date),
            end_date: createTimeString('y/m/d', end_date),
            search,
            el_search,
            company_fd_search,
        });
        loadData();
    }
    function loadMore(e){
        if(page * DEFAULT_ROWS <= total){
            page += 1;
            loadData();
        }
    }
    function loadOrders(){
      let params = {
        ch_no: uniq(list.map(sod=>sod.ch_no))
      };
      setLoadingStatus(true);
      http_request('/purchaseOrder/getByChNo', 'POST', params).then(res=>{
        setLoadingStatus(false);
        if(res.success){
          let data = res.data.purchase_orders || [];
          setOrders(data);
        }else if(res.message === SESSION_EXPIRED_CODE){
            navigate(`${BASE_ROUTE}/logout`);
        }
      });
    }
    function findOrder(ship_detail){
      let find = orders.find(od=>{
        let q1 = od.ch_no === ship_detail.ch_no;
        let q2 = od.ch_seq === ship_detail.ch_seq;
        let q3 = od.el_no === ship_detail.el_no;
        return q1 && q2 && q3;
      });
      return find || {};
    }
    return <div id="page-purchase-ship-list" className="page">
        <ToastContainer 
            position='middle-bottom'
            style={{ zIndex: 1056 }}
            >
            <Toast 
                show={success_toast_show} 
                onClose={()=>{ showSuccessToast(false); }}
                delay={2000}
                autohide
                bg="success"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">已完成</strong>
                </Toast.Header>
                <Toast.Body>{success_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <ToastContainer
            position='middle-bottom'
            style={{ zIndex: 1056 }}
        >
            <Toast 
                show={error_toast_show} 
                onClose={()=>{ showErrorToast(false); }}
                delay={3000}
                autohide
                bg="danger"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">建立失败</strong>
                </Toast.Header>
                <Toast.Body>{error_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <div className={`datepicker_pannel bg-white p-3`}>
        <div className='d-lg-none d-flex align-items-center'>
          <span className='fs-6'>採购出货纪录</span>
          <span className='d-flex flex-grow-1 align-items-center justify-content-end' onClick={()=>{ showFilter(!filter_show); }}>
            {
              filter_show ? <BsChevronCompactUp /> : <BsChevronCompactDown />
            }
          </span>
        </div>
        <Collapse in={filter_show}>
          <div>
            <div className='d-block d-lg-none'>
              <Filter 
                search={search}
                searchLabel="採购单号"
                enableELSearchInput={false}
                company_fd_search={company_fd_search}
                setCompanyFDSearch={setCompanyFDSearch}
                enableCompanyFDSearchInput={true}
                start_date={start_date}
                end_date={end_date}
                setSearch={setSearch}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                query={query}
              />
            </div>
          </div>
        </Collapse>
        <div className='d-none d-lg-block'>
          <Filter 
            search={search}
            searchLabel="採购单号"
            enableELSearchInput={false}
            company_fd_search={company_fd_search}
            setCompanyFDSearch={setCompanyFDSearch}
            enableCompanyFDSearchInput={true}
            start_date={start_date}
            end_date={end_date}
            setSearch={setSearch}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            query={query}
          />
        </div>
      </div>
      <div className={`container p-2 d-flex flex-column`}>
        {
          (list || []).length === 0 && <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
            <span className='text-secondary'>无资料</span>
          </div>
        }
        <ul className='m-0 p-0'>
          {
            list.map((row, r)=><li key={r} className={`item mb-2 p-3`}>
                <div className='id'>{row.ch_no}</div>
                <div className='date'>{row.date}</div>
                <div className='fd-no'>{row.fd_no}</div>
                <div className='order-info d-flex flex-column flex-sm-row'>
                  <div className='order-info-snippet'>
                    <div className='fw-bold text-nowrap me-2'>厂商出货单号：</div>
                    <div>{row.company_fd_no || '--'}</div>
                  </div>
                  <div className='order-info-snippet'>
                    <div className='fw-bold text-nowrap me-2'>建立日期：</div>
                    <div>{createTimeString('y-m-d', new Date(row.date))}</div>
                  </div>
                  <div className='order-info-snippet'>
                    <div className='fw-bold text-nowrap me-2'>签收日期：</div>
                    <div>{row.fd_date ? createTimeString('y-m-d', row.fd_date) : '--'}</div>
                  </div>
                  <div className='order-info-snippet'>
                    <div className='fw-bold text-nowrap me-2'>签收状态：</div>
                    <div>[{getOrderStatus(row.temp_no, row.result)}] {row.temp_no ? '已签收' : (row.result ||'').replace(/^\d+\./, '')}</div>
                  </div>
                </div>
                <table className='w-100 mt-2 detail'>
                  <thead>
                    <tr>
                      <th className='text-center' style={{width: 100}}>採购项次</th>
                      <th>料品编号</th>
                      <th className='text-center' style={{width: 100}}>出货数量</th>
                      <th className='text-center' style={{width: 100}}>单价</th>
                      <th className='text-center' style={{width: 100}}>总金额</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (row.purchase_ship_order_details || []).map((detail, d)=>{
                        let matched_order = findOrder(detail);
                        return <tr key={d}>
                          <td className='text-center'>{detail.ch_seq}</td>
                          <td>{detail.el_no}</td>
                          <td className='text-center'>{detail.ch_qty2} {matched_order.ch_unit}</td>
                          <td className='text-center'>{numberWithComma(matched_order.ch_price || 0)}</td>
                          <td className='text-center'>{numberWithComma(Decimal.add(Decimal.mul(matched_order.ch_price || 0, detail.ch_qty2), matched_order.ch_tax || 0))}</td>
                        </tr>;
                      })
                    }
                  </tbody>
                </table>
            </li>)
          }
        </ul>
        <div className='d-flex align-items-center justify-content-center py-4'>
          {
            (page * DEFAULT_ROWS < total) &&<Button 
              variant='warning' 
              size="sm" 
              className='px-5' 
              onClick={()=>{ loadMore(); }}
            >
              MORE
            </Button>
          }
        </div>
      </div>
    </div>;
}

export default PurchaseShipList;